<template>
    <div>
        <Panel  :title="titleView"  style="margin:0px 1px; ">
            <Form ref="form" :model="model" style="width : 100%; ">
                <fieldset class="c-fieldset">
                    <legend class="c-legend"><b>Filter</b></legend>
                    <table width="100%" cellspacing="1" cellpadding="5" border="0">
                        <tbody>
                            <tr>
                                <td width="10%">Schedule Date</td>
                                <td width="20%">
                                    <DateBox inputId="start" name="start" class="f-field-text" v-model="model.start" format="dd/MM/yyyy"></DateBox>
                                </td>
                                <td width="5%" align="center">to</td>
                                <td width="20%">
                                    <DateBox inputId="end" name="end" class="f-field-text" v-model="model.end" format="dd/MM/yyyy"></DateBox>
                                </td>
                                <td width="5%">Status</td>
                                <td width="15%">
                                    <ComboBox  :data="status" inputId="status" name="status" class="f-field-text" v-model="model.status"></ComboBox>
                                </td>
                                <td width="5%">Client</td>
                                <td width="20%">
                                    <ComboBox  :data="clients" @filterChange="optionClient($event)" inputId="client_id" name="client_id" class="f-field-text" v-model="model.client_id">
                                        <template slot="item" slot-scope="scope">
                                            <span style="font-weight:bold">{{scope.row.text}}</span><br/>
                                            <span style="color:#888">{{scope.row.address}}</span><br/>
                                        </template>
                                        <Addon>
                                            <span v-if="model.client_id" class="textbox-icon icon-clear" title="Clear value" @click="model.client_id=null;"></span>
                                        </Addon>
                                    </ComboBox>
                                </td> 
                                <td width="5%">
                                    <LinkButton :iconCls="icon.iconSearch" @click="loadData()" style="width:80px">{{ btnText.search }}</LinkButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
            </Form>
        </Panel>
        <Panel style="margin:2px 1px; ">
            <div class="datagrid-toolbar">
                <LinkButton v-if="viewGrid"  :plain="true" :iconCls="icon.iconExport" @click="onExport()">{{ btnText.export }}</LinkButton>
            </div>
            <DataGrid
                    ref="dataGrid"
                    :columnResizing="true"
                    :border="false"
                    :loading="dataGrid.loading"                                    
                    :data="dataGrid.rows"
                    :pageSize="dataGrid.pageSize"
                    :pagination="true"
                    :total="dataGrid.total"
                    >                
                <GridColumn align="center" cellCss="datagrid-td-rownumber" width="30">
                    <template slot="body" slot-scope="scope">
                        {{scope.rowIndex + 1}}
                    </template>
                </GridColumn>
                <GridColumn field="client_id" title="Client ID"></GridColumn>
                <GridColumn field="loading_date" title="Loading Date"></GridColumn>
                <GridColumn field="manifest_id" title="Manifest ID"></GridColumn>
                <GridColumn field="trip" title="Trip"></GridColumn>
                <GridColumn field="do_number" title="DO Number"></GridColumn>
                <GridColumn field="so_number" title="SO Number"></GridColumn>
                <GridColumn field="origin" title="Origin"></GridColumn>
                <GridColumn field="dest" title="Customer Name"></GridColumn>
                <GridColumn field="area" title="Area"></GridColumn>
                <GridColumn field="province" title="Province"></GridColumn>
                <GridColumn field="transporter_id" title="Transporter ID"></GridColumn>
                <GridColumn field="vehicle_id" title="Vehicle ID"></GridColumn>
                <GridColumn field="driver_name" title="Driver Name"></GridColumn>
                <GridColumn field="vehicle_type" title="Vehicle Type"></GridColumn>
                <GridColumn field="vehicle_status" title="Vehicle Status"></GridColumn>
                <GridColumn field="time_status" title="Status"></GridColumn>
                <GridColumn field="time_origin_arrival_ata" title="Tiba Muat"></GridColumn>
                <GridColumn field="time_origin_departure_ata" title="Keluar Muat"></GridColumn>
                <GridColumn field="dest_arrival_ata" title="Tiba Bongkar"></GridColumn>
                <GridColumn field="dest_departure_ata" title="Keluar_Bongkar"></GridColumn>
                <GridColumn field="time_origin_note" title="Remaks"></GridColumn>
            </DataGrid>
        </Panel>
    </div>
</template>
<script>
    import GlobalUtil from '@/utils/GlobalUtil';
    import InformationUtil from '@/utils/InformationUtil';
    import IconUtil from '@/utils/IconUtil';
    import ReportService from '@/services/ReportService';
    import OptionService from '@/services/OptionService';

    export default {
        name: 'ActivityView',
        data () {
            return {
                titleView : "Activity Report",
                icon : IconUtil,
                viewGrid : false,
                model : {
                    start : null,
                    end : null,
                    status : 'all',
                    client_id : null
                },
                btnText :{
                    print : InformationUtil.printText,
                    search : InformationUtil.searchText,
                    export : InformationUtil.exportText,
                },
                dataGrid : {
                    loading: false,
                    rows : [],
                    total: 0,
                    pageSize: 10,
                    start : 0,
                    pageLayout: ['list','sep','first','prev','next','last','sep','refresh','info'],
                },
                
                // combobox
                clients : [],
                status : [
                    { value: 0 , text: 'Open' },
                    { value: 3 , text: 'Closed' },
                    { value: 'all' , text: 'All' },
                ],
            }
        },
        methods: {
            async loadData(){
                this.dataGrid.loading = true;
                this.viewGrid = false;

                this.model.start = new Date(this.$moment(this.model.start).format('YYYY-MM-DD'));
                this.model.end = new Date(this.$moment(this.model.end).format('YYYY-MM-DD'));

                let param = {
                    start_date : this.model.start,
                    end_date : this.model.end,
                    status : this.model.status,
                    client_id : this.model.client_id
                }
                
                return ReportService.getData('/activity', this.dataGrid, param)
                    .then((response) => {
                        if(response.data !== "" && response.data !== null){
                            let data = response.data; 
                            this.dataGrid.total = data.total;
                            this.dataGrid.rows = data.rows;
                        }
                        
                        this.dataGrid.loading = false;
                        this.viewGrid = this.dataGrid.rows.length > 0 ? true : false;
                    });
            },
            onExport(){

                this.model.start = new Date(this.$moment(this.model.start).format('YYYY-MM-DD'));
                this.model.end = new Date(this.$moment(this.model.end).format('YYYY-MM-DD'));

                let param = {
                    start_date : this.model.start,
                    end_date : this.model.end,
                    status : this.model.status,
                    client_id : this.model.client_id
                }
                
                ReportService.downloadFile("/activity/export", param)
                            .then((res) => {
                                if(res.type === 'application/vnd.ms-excel' && res != null){
                                    let blob = new Blob([res], { type: "application/vnd.ms-excel" })
                                    let objectUrl = window.URL.createObjectURL(blob)
                                    const elem = window.document.createElement('a')
                                    elem.href = objectUrl;
                                    elem.download = "Report Activity_"+ this.$moment(this.model.start).format('YYYY-MM-DD') + "_"+ this.$moment(this.model.end).format('YYYY-MM-DD') +".xls"
                                    document.body.appendChild(elem)
                                    elem.click()
                                    document.body.removeChild(elem)
                                    window.URL.revokeObjectURL(blob);
                                    window.URL.revokeObjectURL(objectUrl);
                                } else {
                                    this.$messager.alert({
                                        title: "Error",
                                        icon: "error",
                                        msg: res.message
                                    });
                                }
                            }).catch((error) => {
                                this.$refs.notification.error(error);
                            });
            },
            async optionClient(event){
                let search = event == null ? "" : event.filterValue;
                return await OptionService.getOption("/client", search)
                    .then((response) => {
                        this.clients = response.data;
                    }).catch((error) => {
                        this.$refs.notification.error(error);
                    });
            }
        },
        created(){
            this.model.start = new Date();
            this.model.end = new Date();
            GlobalUtil.removeWindow();
        }
    }
    </script>